import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {FITHParsedGameData} from "../../server/data/FITHParsedGameData";
import {TimelineLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {FITHGameModuleConfig} from "../../FITHGameModuleConfig";
import {FITHAvalancheReelController} from "../../reel/FITHAvalancheReelController";
import {FITHWildMiningView} from "./FITHWildMiningView";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {FITHSoundManager} from "../../sound/FITHSoundManager";

export class FITHWildMiningController extends WinPresentationController {
    private _view: FITHWildMiningView;
    private _data: FITHParsedGameData;
    private _timeline: TimelineLite | null;

    private _isFinishCalled: boolean = false;

    constructor(indexes: [number, number]) {
        super(indexes, {
            name: "WildMining",
            skippable: true
        });

        this._view = new FITHWildMiningView();
    }

    protected hasWin(): boolean {
        this._data = (this._gameData as FITHParsedGameData);

        return this._data.wildTransform;
    }

    protected startWinPresentation(): void {
        this._isFinishCalled = false;

        const timeline: TimelineLite = new TimelineLite({
            onComplete: () => this.finish()
        });
        this.addWinAnimationsToTimeline(timeline);
        this._timeline = timeline;
    }

    protected finish(isAborted?: boolean): void {
        if (this._isFinishCalled) {
            return;
        }
        this._isFinishCalled = true;
        super.finish(isAborted);
    }

    protected stopWinPresentation(isAborted: boolean): void {
        if (this._timeline && this._timeline.isActive()) {
            this._view.abort();
            this._timeline.progress(1);

            this._timeline = null;
        }

        // Do no abort the avalanche timeline so it can be continued.
        FITHGameModuleConfig.symbolWinAnimations.reset();
    }

    private addWinAnimationsToTimeline(timeline: TimelineLite): void {
        let startTime: number = 0.2,
            avalancheDelay: number = 0;

        const wildTransformSymbolPositions: boolean[][] = this._data.wildTransformSymbolPositions,
            wildTransformPositions: boolean[][] = this._data.wildTransformPositions,
            baseActiveRowsBefore: number = this._data.baseActiveRowsBefore,
            baseActiveRowsAfter: number = this._data.baseActiveRowsAfter,
            avalancheTimeline: TimelineLite = new TimelineLite({paused: true}),
            allWildPosReelId: number[] = [],
            allWildPosSymId: number[] = [],
            targetPositions: number[][] = [];

        for (let i: number = 0; i < wildTransformPositions.length; i++) {
            const pos: boolean[] = wildTransformPositions[i];

            targetPositions[i] = [];
            for (let j: number = 0; j < pos.length; j++) {
                if (pos[j]) {
                    // #234
                    if (allWildPosReelId.indexOf(i) === -1) {
                        allWildPosReelId.push(i);
                    }
                    allWildPosSymId.push(j);
                    targetPositions[i].push(j);
                }
            }
        }

        timeline.add(this._view.playWildMiningBanner(), startTime);

        wildTransformSymbolPositions.forEach((pos: boolean[], reelId: number) => {
            pos.forEach((hasWin: boolean, symId: number) => {
                if (this.checkIfCanExplodeAway(baseActiveRowsBefore, wildTransformSymbolPositions, reelId, symId)) {
                    timeline.add(this._view.playNonTargetSymbolAnimations(reelId, symId), startTime);
                }
                if (hasWin) {
                    timeline.add(this._view.playTargetSymbolAnimations(reelId, symId, allWildPosReelId, allWildPosSymId, targetPositions), startTime);
                }
            });

            let positions: boolean[] = ArrayHelper.initArrayWithValues(pos.length, () => false);
            for (let i: number = 0; i < positions.length; i++) {
                if (this.checkIfCanExplodeAway(baseActiveRowsBefore, wildTransformPositions, reelId, i)) {
                    positions[i] = true;
                }
            }

            // if there is X symbol in the coming active area's position.
            if (this._data.reels[reelId][baseActiveRowsAfter - 1] === "X") {
                positions[baseActiveRowsAfter - 1] = true;
            }

            avalancheTimeline.add(() => {
                let reel: FITHAvalancheReelController = (Reels.getReel(reelId) as FITHAvalancheReelController);
                reel.reMakeDAsBigSymbol();
            }, avalancheDelay);
            avalancheDelay = Reels.addReelAvalancheToTimeline(reelId, avalancheTimeline, avalancheDelay, reelId !== 0, positions);
        });

        timeline.add(() => {
            avalancheTimeline.play();

            if (baseActiveRowsBefore !== baseActiveRowsAfter) {
                // #218
                FITHSoundManager.playGridDown();

                FITHGameModuleConfig.reelFrameView.moveBarrierDown((baseActiveRowsAfter - baseActiveRowsBefore));
            }
        });
    }

    private checkIfCanExplodeAway(baseActiveRowsBefore: number, positions: boolean[][], reelId: number, symId: number): boolean {
        return (symId < baseActiveRowsBefore && !positions[reelId][symId] && this._data.reels[reelId][symId] !== "X" && this._data.reels[reelId][symId] !== "W" && this._data.reels[reelId][symId] !== "B");
    }
}